import type { IGetUploadFileParams, IGetUploadFileResponse } from 'core/model/interfaces/downloads-uploads';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { initialState, SLICE_NAMESPACE } from '../uploads.constants';
import type { IUploadsState } from '../uploads.types';

export const fetchUploadByFileType = createAppAsyncThunk<IGetUploadFileResponse, IGetUploadFileParams>(
  `${SLICE_NAMESPACE}/fetchUploadByFileType`,
  async (params: IGetUploadFileParams) => {
    try {
      const response = await apiService.uploads.getUploadByFileType(params);

      return response;
    } catch (error) {
      notificationService.drawer.error('Falló al obtener el archivo de carga. Por favor Inténtalo de nuevo.');

      throw error;
    }
  },
);

export const fetchUploadByFileTypeReducer: TSliceExtraReducer<IUploadsState> = builder =>
  builder
    .addCase(fetchUploadByFileType.pending, state => {
      state.upload.loading = true;
      state.upload.success = false;
      state.upload.result = { ...initialState.upload.result };
    })
    .addCase(fetchUploadByFileType.rejected, state => {
      state.upload.loading = false;
      state.upload.success = false;
      state.upload.result = { ...initialState.upload.result };
    })
    .addCase(fetchUploadByFileType.fulfilled, (state, action) => {
      state.upload.loading = false;
      state.upload.success = true;
      state.upload.result = action.payload;
    });
